// src/pages/b2b/B2BSurveyDeployPage.js - 설문 배포 및 관리 페이지 (더미)

import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import B2BLayout from '../../components/b2b/B2BLayout';
import { usePageHeader } from '../../context/PageHeaderContext';
import './B2BSurveyDeployPage.scss';

const B2BSurveyDeployPage = () => {
  const { studySlug } = useParams();
  const navigate = useNavigate();

  usePageHeader({
    title: '설문 배포 및 관리',
    subtitle: '생성된 설문을 브랜드 패널에 배포하고 관리하세요',
    showBack: true,
    onBack: () => navigate(`/b2b/study/${studySlug}`),
  });

  return (
    <B2BLayout hideCollapseButton={false} defaultCollapsed={true}>
      <div className="b2b-survey-deploy-page">
        <div className="b2b-page-content">
          <div className="b2b-placeholder">
            <p>준비 중입니다...</p>
          </div>
        </div>
      </div>
    </B2BLayout>
  );
};

export default B2BSurveyDeployPage;

